/**
 * 新上传目录。过期清理只在后台做，这里只提供上传前缀。
 * 新对象统一放在 n/ 下，和旧目录分开。
 */
export const OSS_NEW_ROOT = "n";

export const OSS_BUCKET = {
  PRIVATE: "yxmgt-private",
  PUBLIC: "yxmgt-public"
};

function pad(month) {
  return month < 10 ? "0" + month : String(month);
}

export function ossMonthDir(prefix, ownerId) {
  const now = new Date();
  const month = `${now.getFullYear()}/${pad(now.getMonth() + 1)}`;
  const base = withNewRoot(prefix);
  if (ownerId !== undefined && ownerId !== null && ownerId !== "") {
    return `${base}/${ownerId}/${month}`;
  }
  return `${base}/${month}`;
}

function withNewRoot(prefix) {
  const base = String(prefix || "")
    .replace(/^\/+/, "")
    .replace(/\/+$/, "");
  if (!base || base === OSS_NEW_ROOT || base.startsWith(`${OSS_NEW_ROOT}/`)) {
    return base;
  }
  return `${OSS_NEW_ROOT}/${base}`;
}

export function buildObjectKey(filePath, fileName) {
  const base = String(filePath || "")
    .replace(/^\/+/, "")
    .replace(/\/+$/, "");
  if (!base || !fileName) {
    return "";
  }
  return `${base}/${fileName}`;
}

export const OssPath = {
  marketingAd: () => ossMonthDir("marketing/ad"),
  marketingWecom: () => ossMonthDir("marketing/wecom"),
  marketingPoiImg: () => ossMonthDir("marketing/poi/img"),
  marketingPoiVideo: () => ossMonthDir("marketing/poi/video"),
  marketingRecPoint: () => ossMonthDir("marketing/rec-point"),
  partnerPublic: () => ossMonthDir("partner/public"),
  partnerCredential: () => ossMonthDir("partner/credential"),
  partnerBill: () => ossMonthDir("partner/bill"),
  vehicleType: () => ossMonthDir("vehicle/type"),
  vehicleLicense: () => ossMonthDir("vehicle/license"),
  vehicleInsurance: () => ossMonthDir("vehicle/insurance"),
  vehicleAnomaly: () => ossMonthDir("vehicle/anomaly"),
  vehicleTire: () => ossMonthDir("vehicle/tire"),
  driverContract: (driverId) => ossMonthDir("driver/contract", driverId || "unknown"),
  driverCredential: (driverId) => ossMonthDir("driver/credential", driverId || "unknown"),
  driverHire: (driverId) => ossMonthDir("driver/hire", driverId || "unknown"),
  driverNotice: () => ossMonthDir("driver/notice"),
  driverPunish: () => ossMonthDir("driver/punish"),
  trainingLegacy: () => ossMonthDir("training/legacy"),
  trainingVideo: () => ossMonthDir("training/video"),
  trainingMaterial: () => ossMonthDir("training/material"),
  trainingExam: () => ossMonthDir("training/exam"),
  trainingExamOption: () => ossMonthDir("training/exam/option"),
  passengerInvoice: () => ossMonthDir("passenger/invoice"),
  orderComplaint: () => ossMonthDir("order/complaint"),
  orderFeedback: () => ossMonthDir("order/feedback"),
  orderAppeal: () => ossMonthDir("order/appeal"),
  orderEvaluation: () => ossMonthDir("order/evaluation"),
  workflowQuestion: () => ossMonthDir("workflow/question"),
  workflowResult: () => ossMonthDir("workflow/result"),
  orderProblemChat: () => ossMonthDir("order/problem/chat"),
  problemFlow: () => ossMonthDir("problem/flow"),
  qcEvidence: () => ossMonthDir("qc/evidence"),
  qcTel: () => ossMonthDir("qc/tel"),
  qcSnapshot: () => ossMonthDir("qc/snapshot"),
  kefuWecom: () => ossMonthDir("kefu/wecom")
};
